export const xsfrToken = async () => Promise.resolve();
